import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useContent() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios.get(`${API}/content`).then(({ data }) => setContent(data)).catch(() => setContent({}));
  }, []);
  return content;
}
